import React from "react";
import IframePage from "./IframePage";
import "../../../css/BoletinOficial/resoluciones-generales.css";

const ResolucionesGenerales = () => (
  <IframePage
    title="Resoluciones Generales"
    description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
    iframeUrl="https://ciudaddeoliva.gov.ar/boletin-oficial/resoluciones-generales.aspx"
    classPrefix="resoluciones-generales"
  />
);

export default ResolucionesGenerales;
